import { Button, Modal } from "antd";
import {
  CheckCircleFilled,
  CloudDownloadOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ModalTitle from "../ModalTitle";
import Illustration from "./Illustration";
import styles from "./styles.module.css";

const HIGHLIGHTS = [
  "آخرین قابلیت‌ها و بهبودهای تسکامون رو می‌گیری.",
  "اشکال‌های شناخته‌شده‌ی نسخه‌ی فعلی برطرف می‌شه.",
  "چیزی از کارت پاک نمی‌شه؛ فقط صفحه دوباره بارگذاری می‌شه.",
];

const UpdateAppModal = ({ isOpen, setIsOpen, onUpdate }) => {
  const navigate = useNavigate();

  const openChangelog = () => {
    setIsOpen(false);
    navigate("/changelog");
  };

  return (
    <Modal
      className="ds-modal"
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      centered
      width={480}
      title={
        <ModalTitle
          icon={<CloudDownloadOutlined />}
          title="نسخه جدید از راه رسیده!"
          subtitle="برای بهبود عملکرد تسکامون بروزرسانی کنید."
        />
      }
      footer={
        <div className={styles.footer}>
          <Button type="link" icon={<HistoryOutlined />} onClick={openChangelog}>
            تغییرات نسخه
          </Button>
          <div className={styles.footerActions}>
            <Button onClick={() => setIsOpen(false)}>بعدا</Button>
            <Button
              type="primary"
              icon={<CloudDownloadOutlined />}
              onClick={() => onUpdate()}
            >
              بروزرسانی
            </Button>
          </div>
        </div>
      }
    >
      <Illustration />

      <div className={styles.highlights}>
        {HIGHLIGHTS.map((text) => (
          <div key={text} className={styles.highlight}>
            <CheckCircleFilled className={styles.highlightIcon} />
            <span>{text}</span>
          </div>
        ))}
      </div>

      <span className={styles.note}>
        بروزرسانی چند ثانیه بیشتر طول نمی‌کشه.
      </span>
    </Modal>
  );
};

export default UpdateAppModal;
